<div class="horizontal-tab-container">
    <div class="tab-navigation">
        <div class="tab-list">
            <div 
                *ngFor="let tab of tabs; let i = index; trackBy: trackByIndex" 
                class="tab-item" 
                [class.active]="activeTab === tab.id"
                (click)="setActiveTab(tab.id)"
            >
                <span class="tab-number">{{ i + 1 }}</span>
                <span class="tab-label">{{ tab.title }}</span>
            </div>
        </div>
    </div>
</div>
